export enum ToastType{
    Warning,
    Success,
    Error,
    Info
}